import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";

const TINTA = "#0b1f4b";

// Recuadro de firma a pulso: dedo, lápiz táctil o mouse. Fondo transparente.
export const SignaturePad = forwardRef(function SignaturePad({ onChange }, ref) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const [vacio, setVacio] = useState(true);

  const preparar = useCallback(() => {
    const cv = canvasRef.current;
    const r = cv.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    cv.width = r.width * dpr;
    cv.height = r.height * dpr;
    const ctx = cv.getContext("2d");
    ctx.scale(dpr, dpr);
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = TINTA;
    setVacio(true);
    onChange?.(true);
  }, [onChange]);

  useEffect(() => { preparar(); }, [preparar]);

  const punto = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top, t: Date.now(), p: e.pressure || 0.5 };
  };
  const down = (e) => {
    e.preventDefault();
    canvasRef.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    last.current = punto(e);
  };
  const move = (e) => {
    if (!drawing.current) return;
    const p = punto(e);
    const l = last.current;
    const ctx = canvasRef.current.getContext("2d");
    const vel = Math.hypot(p.x - l.x, p.y - l.y) / Math.max(1, p.t - l.t);
    const presion = e.pointerType === "pen" ? 0.6 + p.p : 1;
    ctx.lineWidth = Math.max(1.3, Math.min(3.4, (3.2 - vel * 0.9) * presion));
    ctx.beginPath();
    ctx.moveTo(l.x, l.y);
    ctx.quadraticCurveTo(l.x, l.y, (l.x + p.x) / 2, (l.y + p.y) / 2);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    last.current = p;
    if (vacio) { setVacio(false); onChange?.(false); }
  };
  const up = () => { drawing.current = false; };

  useImperativeHandle(ref, () => ({
    limpiar: () => { const cv = canvasRef.current; cv.getContext("2d").clearRect(0, 0, cv.width, cv.height); setVacio(true); onChange?.(true); },
    imagen: () => canvasRef.current.toDataURL("image/png"),
    vacio: () => vacio,
  }));

  return (
    <div className="relative rounded-xl border-2 border-dashed border-slate-300 bg-white">
      <canvas
        ref={canvasRef}
        className="block h-48 w-full cursor-crosshair touch-none sm:h-56"
        onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} onPointerCancel={up}
        data-testid="firma-canvas"
      />
      <div className="pointer-events-none absolute inset-x-6 bottom-10 border-b border-slate-300" />
      {vacio && <p className="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 text-center text-sm text-slate-400">Dibuja aquí tu firma con el dedo, lápiz o mouse</p>}
    </div>
  );
});
